// Tema unică „La Cafea”: alb lăptos, cafea, negru, roșu — valorile sunt în index.css (:root).
export const FRAMES = {
  moale: { label: "Rotunjite mult", radius: "1.5rem" },
  delicat: { label: "Rotunjite delicat", radius: "0.6rem" },
  drept: { label: "Colțuri drepte", radius: "0px" },
};

// Fundalurile fotografice ale paginilor: cheie setare → variabilă CSS (implicitul e în index.css).
export const BACKGROUND_SLOTS = [
  { key: "bg_home", cssVar: "--bg-home", label: "Prima pagină — antetul", file: "home.jpg" },
  { key: "bg_writings", cssVar: "--bg-writings", label: "Prima pagină — lista de însemnări", file: "gallery.jpg" },
  { key: "bg_post", cssVar: "--bg-post", label: "Pagina unei însemnări", file: "post.jpg" },
  { key: "bg_about", cssVar: "--bg-about", label: "Despre mine", file: "about.jpg" },
  { key: "bg_talk", cssVar: "--bg-talk", label: "Hai la o cafea", file: "talk.jpg" },
  { key: "bg_questions", cssVar: "--bg-questions", label: "Cutia cu întrebări anonime", file: "questions.jpg" },
];

const absolute = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

export const applyTheme = (settings = {}) => {
  const rootStyle = document.documentElement.style;
  const frame = FRAMES[settings.frame_style];
  if (frame) rootStyle.setProperty("--frame", frame.radius);
  else rootStyle.removeProperty("--frame");
  BACKGROUND_SLOTS.forEach(({ key, cssVar }) => {
    const url = absolute(settings[key]);
    if (url) rootStyle.setProperty(cssVar, `url("${url}")`);
    else rootStyle.removeProperty(cssVar);
  });
};
